import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { SchoolService } from "../../../../../shared/services/school.service";
import { AcademyService } from "../../../../Report/report-services/academy.service";
import { GradeLevelService } from "../../../../Report/report-services/grade-level.service";
import { GroupService } from "../../../../Report/report-services/group.service";
import { HomeroomService } from "../../../../Report/report-services/homeroom.service";
import { BTStudentRouteRequest } from "../../shared/BTStudentRouteRequest";
import { BTStudentsToAssignRequest } from "../../shared/BTStudentsToAssignRequest";
import { DataService_BusTrackerBusMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-assign-students",
	templateUrl: "./assign-students.component.html",
	styleUrls: ["./assign-students.component.css"],
})
export class AssignStudentsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentService: DataService_BusTrackerBusMaintenance
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadPerson();

		this.SelectedRoute = this.dialogConfig.data.SelectedRoute;

		this.BusRouteNbr = this.SelectedRoute.BusRouteNbr;
		this.BusRouteDesc = this.SelectedRoute.BusRouteDesc;
		this.BusRouteTypeDesc = this.SelectedRoute.BusRouteTypeDesc;

		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	BusRouteNbr: any = "";
	BusRouteDesc: any = "";
	BusRouteTypeDesc: any = "";

	Processing: any = false;

	ApplicationItemID: any = "12D5E11E-DC27-4C79-B97F-F21518B332A8";

	SelectedRoute: any;

	SchoolLoading: any = false;
	School: any;
	lstSchool: any = [];

	GradeLevelLoading: any = false;
	GradeLevel: any;
	lstGradeLevel: any = [];

	AcademyLoading: any = false;
	Academy: any;
	lstAcademy: any = [];

	HomeroomLoading: any = false;
	Homeroom: any;
	lstHomeroomData: any = [];

	GroupLoading: any = false;
	Group: any;
	lstGroup: any = [];

	ActiveID: any = 1;
	// lstActive: any = [
	//   {
	//     ID: -1,
	//     Desc: "All"
	//   },
	//   {
	//     ID: 1,
	//     Desc: "Active"
	//   },
	//   {
	//     ID: 0,
	//     Desc: "Inactive"
	//   }
	// ];

	Filter: any = "";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any = [];
	lstPerson: any = [];

	//Filter lists
	lstSchoolFullName: any = [];
	lstGradeLevelDesc: any = [];
	lstHomeroom: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "GradeLevelDesc", header: "Grade Level" },
		{ field: "Homeroom", header: "Homeroom" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		var result = this.schoolService.loadSchoolList(this.ApplicationItemID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolName: "All",
					SchoolFullName: "All",
				});

				this.School = this.lstSchool[0];

				this.loadGradeLevel();
			},
			(error) => {}
		);
	}

	loadGradeLevel() {
		var result = this.gradelevelService.loadGradeLevelList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.GradeLevel = this.lstGradeLevel[0];

				this.loadAcademy();
			},
			(error) => {}
		);
	}

	loadAcademy() {
		var result = this.academyService.loadAcademyList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.Academy = this.lstAcademy[0];

				this.loadHomeroom();
			},
			(error) => {}
		);
	}

	loadHomeroom() {
		var result = this.homeroomService.loadHomeroomList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroomData = response;

				if (this.lstHomeroomData.length == 0) {
					this.lstHomeroomData.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.Homeroom = this.lstHomeroomData[0];

				this.loadGroup();
			},
			(error) => {}
		);
	}

	loadGroup() {
		var result = this.groupService.loadGroupList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.Group = this.lstGroup[0];
			},
			(error) => {}
		);
	}

	loadPerson() {
		this.loading = true;

		this.SelectedPersons = [];

		let parms: BTStudentsToAssignRequest = {
			BusRouteID: this.SelectedRoute.BusRouteID,
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevel.GradeLevelID,
			AcademyID: this.Academy.AcademyId,
			HomeroomID: this.Homeroom.HomeroomId,
			GroupID: this.Group.GroupID,
			Active: this.ActiveID,
			UserID: this.user.userID,
			Filter: this.Filter,
		};

		var result = this.StudentService.StudentsToAssignSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				this.lstSchoolFullName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolFullName))).sort();
				this.lstGradeLevelDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.GradeLevelDesc))).sort();
				this.lstHomeroom = Array.from(new Set(this.lstPerson.map((item: any) => item.Homeroom))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	//Custom Button Methods
	onAssign() {
		this.errorMessage = "";

		if (this.SelectedPersons.length == 0) {
			this.errorMessage = "Select students to assign";
			return;
		}

		//
		// Create Request
		//
		this.Processing = true;

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			lstIDs = [...lstIDs, next.PersonID];
		}

		let parms: BTStudentRouteRequest = {
			BusRouteID: this.SelectedRoute.BusRouteID,
			lstPersonIDs: lstIDs,
			DefinedByID: 4,
		};

		//
		// Call SP
		//
		var result = this.StudentService.StudentsAssignToRoute(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Students were assigned successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign students",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		//Load Data
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		// this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		// this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		// this.SelectedPerson = Person;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return (
			this.loading == true ||
			this.SchoolLoading == true ||
			this.GradeLevelLoading == true ||
			this.AcademyLoading == true ||
			this.HomeroomLoading == true ||
			this.GroupLoading == true
		);
	}

	////////////////////////////////////////////
}
